function convertDataStructureToCommonEnture(data, types='AirportBus,Bus,AirportTrain,Train,Boat,Metro,Tram') {
    const rows = _.get(data,'data.stopPlace.estimatedCalls',[]);
    
    const typesMap = {
        Bus: 'bus',
        Train: 'rail',
        Boat: 'water'
    };
    const filteredByTransportType = rows.filter(el => _.get(el,'serviceJourney.journeyPattern.line.transportMode') === typesMap[types]);
    const results = []

    filteredByTransportType.forEach(element => {
        const platformNumber = _.get(element,'quay.publicCode', 'NotSet')

        // find platform
        let platform = results.find(p => p.number === platformNumber)

        // if no platform in results - Add new platform
        if(!platform){
            platform = { number: platformNumber, trains: [] }
            results.push(platform)
        }
        // Get line id
        const lineId = _.get(element,'serviceJourney.journeyPattern.line.publicCode')
        // Find a train in on platform in results
        let train =  platform.trains.find(p => p.routeId == lineId) // lineId is string

        // if no train in results - Add new train
        if(!train){
            train = { routeId: lineId, times: [], warnings:[]}
            platform.trains.push(train)
        }

        train.type = _.get(element,'serviceJourney.journeyPattern.line.transportSubmode');
        train.name = _.get(element,'serviceJourney.journeyPattern.line.name');
        train.route = _.get(element,'serviceJourney.journeyPattern.line.publicCode', 'NotSet');
        train.destination = _.get(element,'destinationDisplay.frontText', 'NotSet');
        train.warnings = _.get(element,'situations', []).map(w => w.summary.map( s => s.value).join('; '));
        train.times.push( element.actualDepartureTime || element.expectedDepartureTime || element.aimedDepartureTime );

    })

    return results
}

export {
    convertDataStructureToCommonEnture
}
